import postRequest from '../../../../../postRequest';

/**
 * Calls skus endpoint to get skus mapped to that product.
 *
 * @param {number} productId - 15974689
 * @param {string} siteCode - JD
 * @returns {Promise} { data: { Data: [{}], Pagination: {} }, status: 200 }
 */
async function postSkus(productId, siteCode) {
  const endpoint = '/integration-pim/v1/products/drop-shipment/skus';

  const body = {
    productId,
    siteCode,
  };
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'SKUs')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postSkus;
